import React, { useState, useEffect, useRef } from 'react'
import { Button, Card, Modal, Popconfirm } from 'antd'
import {
  paginationInit,
  formatMessage,
  formatMessageNew,
  dateTrans,
  downLoadFileBlob,
  formatStartTime,
  formatEndTime
} from '@/utils/common'
import { getTagReportExport } from '@/services/SendList/SendList'
import { configQuery } from '@/services/configuration/config'
import dayjs from 'dayjs'
import { messageModal } from '@/utils/modalUtils'
import {
  nfcReportList,
  // getNFCUpdateTime,
  reportRetryBind,
  reportTagDisability
  // reportTagUnbind
} from '@/services/configuration/config'
import { SEND_STATUS_UPPER } from '@/utils/types'
import AntdTable from '@/components/table/AntdTable'
import SearchBar from '@/components/searchbar/SearchBar'
import ActionBar from '@/components/table/ActionBar'
import NfcUIDModalTable from './components/nfcUIDModalTable'
import { useSelector } from 'react-redux'
import moment from 'moment'
import { hasPermission } from '@/annotations/nike-react'
import { modalError } from '@/utils/modalUtils'

const dateFormat = 'YYYY-MM-DD'
const startMonth = dayjs()
  .subtract(1, 'months')
  .add(1, 'day')
const endMonth = dayjs()
const menu_nfc_report_nfcUidReport = 'menu_nfc_report_nfcUidReport'
const menu_nfc_uid_report_status_view = 'menu_nfc_uid_report_status_view'
const NFCUIDReportPage = () => {
  const commonStore = useSelector(state => state.commonStore)
  const language = useSelector(state => state.commonStore.language)
  const mounting = useRef(false)
  let formRef = useRef(null)
  const tableColumnsAll = [
    {
      title: formatMessage(commonStore, 'languageObj.nfcUIDReport.nfcUID'),
      dataIndex: 'tagUid',
      fixed: 'left',
      render: text => {
        return (
          <div
            className="link_name"
            onClick={() => {
              tableItemClick(text)
            }}
          >
            {text}
          </div>
        )
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcUIDReport.productCode'),
      dataIndex: 'productCode'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcUIDReport.productName'),
      dataIndex: 'productName'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcUIDReport.size'),
      dataIndex: 'productSize'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcUIDReport.upc'),
      dataIndex: 'upc'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcUIDReport.requiredChannel'),
      dataIndex: 'channel',
      width: 100,
      render: text => <div>{text}</div>
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcUIDReport.tagTypeDesc'),
      dataIndex: 'tagDesc',
      width: 180,
      render: text => <div>{text}</div>
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcUIDReport.plant'),
      dataIndex: 'plantCode'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcUIDReport.status'),
      dataIndex: 'status'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcUIDReport.tagStatus'),
      dataIndex: 'bindStatus'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcUIDReport.workstation'),
      dataIndex: 'workstation'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcUIDReport.orderNumber'),
      dataIndex: 'orderNumber'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcUIDReport.taggingDate'),
      dataIndex: 'taggingTime',
      render: text => {
        return text ? dateTrans(text) : ''
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcUIDReport.sendDate'),
      dataIndex: 'sendAntTime',
      render: text => {
        return text ? dateTrans(text) : ''
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcUIDReport.sendStatus'),
      dataIndex: 'sendAntStatus'
    },
    {
      title: formatMessage(commonStore, 'languageObj.emailNfcUIDSentFailureReport.exceptionCode'),
      dataIndex: 'exceptionCode'
    },
    {
      title: formatMessage(commonStore, 'languageObj.emailNfcUIDSentFailureReport.exceptionType'),
      dataIndex: 'exceptionType'
    },
    {
      title: formatMessage(commonStore, 'languageObj.nfcUIDReport.action'),
      dataIndex: 'action',
      render: (text, record) => {
        // const noUnbindPermission = !hasPermission('menu_nfc_report_nfcUidReport_view_button_unbind')
        const noDisableAndUnbindPermission = !hasPermission('menu_nfc_report_nfcUidReport_view_button_disable')
        const disabled = noDisableAndUnbindPermission || record.status === 'Disabled' || record.bindStatus !== 'TAGGED'
        // const disabledUnbind = noUnbindPermission || record.bindStatus !== 'TAGGED' || record.status === 'Disabled'
        return (
          <div>
            <Popconfirm
              title={formatMessage(commonStore, 'languageObj.commonLocale.disableMessage')}
              onConfirm={() => disableItem(record)}
              disabled={disabled}
            >
              <Button disabled={disabled} type="primary">
                {formatMessage(commonStore, 'languageObj.commonLocale.disable')}
              </Button>
            </Popconfirm>
            {/* <Popconfirm
              title={formatMessage(commonStore, 'languageObj.nfcUIDReport.unbindMessage')}
              onConfirm={() => unbindItem(record)}
              disabled={disabledUnbind}
            >
              <Button disabled={disabledUnbind} type="primary">
                {formatMessage(commonStore, 'languageObj.nfcUIDReport.unbind')}
              </Button>
            </Popconfirm> */}
          </div>
        )
      }
    }
  ]
  let tableColumns = []

  let searchListInitAll = [
    {
      type: 'input',
      label: 'languageObj.nfcUIDReport.nfcUID',
      key: 'nfcUID',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.nfcUIDReport.plant',
      key: 'plant',
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'input',
      label: 'languageObj.nfcUIDReport.tagTypeDesc',
      key: 'tagTypeDesc',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.nfcUIDReport.tagStatus',
      key: 'tagStatus',
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [
        { value: 'TAGGED', label: 'Tagged' },
        { value: 'NOT_TAGGED', label: 'Not Tag' }
      ],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.nfcUIDReport.sendStatus',
      key: 'sendStatus',
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: SEND_STATUS_UPPER,
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'timeRange',
      label: 'languageObj.nfcUIDReport.taggingDate',
      key: 'taggingDate',
      format: dateFormat,
      disabledDate: current => {
        let falg =
          (current &&
            current <
              moment()
                .subtract(1, 'year')
                .subtract(1, 'day')) ||
          (current && current > moment().endOf('day'))
        return falg
      },
      initialValues: [startMonth, endMonth],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.nfcUIDReport.requiredChannel',
      key: 'channels',
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'false'
    },
    {
      type: 'input',
      label: 'languageObj.nfcUIDReport.productCode',
      key: 'productCode',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'false'
    },
    {
      type: 'input',
      label: 'languageObj.nfcUIDReport.upc',
      key: 'upc',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'flase'
    },
    {
      type: 'select',
      label: 'languageObj.nfcUIDReport.status',
      key: 'status',
      selectList: [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
        { value: 'Disabled', label: 'Disabled' }
      ],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'false'
    },
    {
      type: 'input',
      label: 'languageObj.nfcUIDReport.workstation',
      key: 'workstation',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'false'
    },
    {
      type: 'input',
      label: 'languageObj.nfcUIDReport.orderNumber',
      key: 'orderNumber',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'false'
    },
    {
      type: 'timeRange',
      label: 'languageObj.nfcUIDReport.sendDate',
      key: 'sendDate',
      format: dateFormat,
      disabledDate: current => {
        let falg =
          (current &&
            current <
              moment()
                .subtract(1, 'year')
                .subtract(1, 'day')) ||
          (current && current > moment().endOf('day'))
        return falg
      },
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'false'
    },
    {
      type: 'input',
      label: 'languageObj.emailNfcUIDSentFailureReport.exceptionCode',
      key: 'exceptionCode',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'false'
    },
    {
      type: 'input',
      label: 'languageObj.emailNfcUIDSentFailureReport.exceptionType',
      key: 'exceptionType',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'false'
    }
  ]

  let accessLs = ['sendAntTime', 'sendAntStatus', 'sendStatus', 'sendDate', 'exceptionCode', 'exceptionType']
  let searchListInit = []
  if (hasPermission(menu_nfc_uid_report_status_view)) {
    tableColumns = tableColumnsAll
    searchListInit = searchListInitAll
  } else {
    tableColumns = tableColumnsAll.filter(item => {
      return !accessLs.includes(item.dataIndex)
    })
    searchListInit = searchListInitAll.filter(item => {
      return !accessLs.includes(item.key)
    })
  }

  const [tableList, setTableList] = useState([])
  // const [updateTime, setUpdateTime] = useState(0)
  const [searchList, setSearchList] = useState(searchListInit)
  const [queryFlag, setQueryFlag] = useState(false)
  const [pagination, setPagination] = useState(paginationInit)
  const [modalVisible, setModalVisible] = useState(false)
  const [selectProductCode, setSelectProductCode] = useState(false)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])

  useEffect(() => {
    // lastUpdateTime()
    searchPlantAndChannel()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const searchPlantAndChannel = () => {
    let num = 99999999
    const params1 = {
      configKey: 'plant_code',
      configStatus: true,
      configType: 'plant_code_config',
      pageNo: 1,
      size: num,
      total: num
    }

    const params2 = {
      configKey: 'channel',
      configStatus: true,
      configType: 'channel_config',
      pageNo: 1,
      size: num,
      total: num
    }
    Promise.all([configQuery(params1), configQuery(params2)]).then(res => {
      try {
        searchListInit.forEach(itemFirst => {
          if (itemFirst.key === 'plant' || itemFirst.key === 'channels') {
            let arr = []
            switch (itemFirst.key) {
              case 'plant':
                let res0 = res[0].resultData.records
                for (let index = 0; index < res0.length; index++) {
                  const element = res0[index]
                  arr.push({
                    label: element.configValue,
                    value: element.configValue
                  })
                }
                break
              case 'channels':
                let res1 = res[1].resultData.records
                for (let index = 0; index < res1.length; index++) {
                  const element = res1[index]
                  arr.push({
                    label: element.configValue,
                    value: element.configValue
                  })
                }
                break
              default:
                break
            }
            itemFirst.selectList = arr
          }
        })
        setSearchList([...searchListInit])
      } catch (error) {}
    })
  }
  // const lastUpdateTime = () => {
  //   getNFCUpdateTime({}).then(res => {
  //     if (res.errorCode === '200') {
  //       if (res?.resultData > 0) {
  //         setUpdateTime(res.resultData)
  //       }
  //     }
  //   })
  // }

  useEffect(() => {
    if (mounting.current) searchDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])
  const searchDataBtn = () => {
    const pg = {
      ...pagination,
      currentPage: 1
    }
    mounting.current = true
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }
  const searchClearDataBtn = () => {
    // formRef && formRef.current.clearForm()
    const pg = {
      ...pagination,
      currentPage: 1
    }
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }
  const handleTableChange = pagina => {
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination({ ...params })
    setQueryFlag(!queryFlag)
  }
  const getParams = () => {
    let info = {}
    info = (formRef.current && formRef.current.getSearchValue()) || {}
    console.log(info)
    const { taggingDate, sendDate } = info
    const params = {
      tagUid: info.nfcUID,
      plantCodes: info.plant,
      channels: info.channels,
      tagDesc: info.tagTypeDesc,
      tagStatusList: info.tagStatus,
      sendAntStatusList: info.sendStatus,
      taggingTimeStart: formatStartTime(taggingDate),
      taggingTimeEnd: formatEndTime(taggingDate),
      productCode: info.productCode,
      upc: info.upc,
      status: info.status,
      workstation: info.workstation,
      orderNumber: info.orderNumber,
      sendDateStart: formatStartTime(sendDate),
      sendDateEnd: formatEndTime(sendDate),
      exceptionCode: info.exceptionCode,
      exceptionType: info.exceptionType
    }
    return params
  }
  const searchDataFun = () => {
    const params = {
      ...getParams(),
      size: pagination.pageSize,
      pageNo: pagination.currentPage,
      total: pagination.total
    }
    nfcReportList(params)
      .then(res => {
        const dt = res.resultData
        setTableList(dt.records)
        const pg = {
          ...pagination,
          total: dt.total
        }
        setPagination(pg)
      })
      .catch(error => {
        if (error.errorCode === '441') {
          modalError({
            content: formatMessage(commonStore, 'languageObj.nfcUIDReport.dateLimt')
          })
        }
      })
  }

  const downLoadFun = () => {
    const params = {
      ...getParams(),
      isChinese: language === 'zh_CN' ? true : false
    }
    getTagReportExport(params).then(res => {
      downLoadFileBlob(res)
    })
  }

  const disableItem = record => {
    let params = {
      plantCode: record.plantCode,
      // upc: record.upc,
      nfcUid: record.tagUid,
      operator: localStorage.getItem('account')
      // plantCode: '1023',
      // upc: '000123123',
      // nfcUid: 'HHOU7H0208000001019',
    }
    reportTagDisability(params)
      .then(res => {
        console.log(res)
        messageModal('success', {
          content: formatMessage(commonStore, 'languageObj.commonLocale.success')
        })
        setQueryFlag(!queryFlag)
      })
      .catch(error => {
        let errormessage = 'languageObj.httpLocale.requestError'
        if (error.errorCode === '2004') {
          errormessage = 'languageObj.nfcUIDReport.disableError'
        }
        modalError({
          content: formatMessage(commonStore, errormessage)
        })
      })
  }

  // const unbindItem = record => {
  //   const params = {
  //     plantCode: record.plantCode,
  //     nfcUid: record.tagUid,
  //     operator: localStorage.getItem('account')
  //   }
  //   reportTagUnbind(params)
  //     .then(res => {
  //       console.log(res)
  //       setQueryFlag(!queryFlag)
  //     })
  //     .catch(error => {
  //       let errormessage = 'languageObj.httpLocale.requestError'
  //       if (error.errorCode === '952') {
  //         errormessage = 'languageObj.nfcUIDReport.unbindError1'
  //       } else if (error.errorCode === '420') {
  //         errormessage = 'languageObj.nfcUIDReport.unbindError2'
  //       }
  //       modalError({
  //         content: formatMessage(commonStore, errormessage)
  //       })
  //     })
  // }

  const tableItemClick = code => {
    setSelectProductCode(code)
    setModalVisible(true)
  }

  const handleModalCancel = () => {
    setModalVisible(false)
  }

  const handleModalOk = () => {
    setModalVisible(false)
  }

  const reSendFun = () => {
    // const ids = selectedRowKeys.map(item => {
    //   return tableList[item].id
    // })
    let params = selectedRowKeys
    reportRetryBind(params).then(res => {
      if (res.errorCode === '200') {
        messageModal('success', {
          content: formatMessage(commonStore, 'languageObj.commonLocale.success')
        })
        setQueryFlag(!queryFlag)
        setSelectedRowKeys([])
      } else if (res.errorCode === '951') {
        const data = res.resultData
        const keys = Object.keys(data)
        let resList = keys.map(itemId => {
          return tableList.find(findItem => findItem.tagUid === itemId)
        })
        let str = resList.map(strItem => {
          return `${strItem.productCode}/${strItem.tagUid}`
        })
        modalError(
          {
            content: (
              <div>
                {formatMessageNew('languageObj.commonLocale.products')}&nbsp;{str.join('、')}&nbsp;
                {formatMessageNew('languageObj.commonLocale.resendFailed')}
              </div>
            )
          },
          () => {
            // setQueryFlag(!queryFlag)
            // setSelectedRowKeys([])
          }
        )
      }
    })
  }
  const onSelectChange = newSelectedRowKeys => {
    setSelectedRowKeys(newSelectedRowKeys)
  }
  const rowSelection = {
    selectedRowKeys,
    getCheckboxProps: record => ({
      disabled: record.sendAntStatus !== 'FAILED' || record.status === 'Disabled'
    }),
    onChange: onSelectChange
  }
  const hasSelected = selectedRowKeys.length > 0
  return (
    <div>
      <Card bordered={false} bodyStyle={{ padding: 4 }}>
        <div className="search-bar">
          <SearchBar
            ref={formRef}
            searchList={searchList}
            layout={{ labelCol: { span: 10 }, wrapperCol: { span: 14 } }}
            showCollapseBtn={true}
            showSearchBtn={true}
            showClearBtn={true}
            onSearch={searchDataBtn}
            onClear={searchClearDataBtn}
          />
        </div>
        <div className="content-container">
          <ActionBar onDownload={downLoadFun} style={{ alignItems: 'end', marginTop: 15 }}>
            {hasPermission(menu_nfc_report_nfcUidReport) ? (
              <Button type="primary" className="mr20" disabled={!hasSelected} onClick={reSendFun}>
                {formatMessage(commonStore, 'languageObj.commonLocale.resend')}
              </Button>
            ) : null}
          </ActionBar>
          {/* <div className="opt_btn mb15" style={{ display: 'flex' }}>
            {hasPermission(menu_nfc_report_nfcUidReport) ? (
              <Button type="primary" className="mr20" disabled={!hasSelected} onClick={reSendFun}>
                {formatMessage(commonStore, 'languageObj.commonLocale.resend')}
              </Button>
            ) : null}
            <Button type="primary" onClick={downLoadFun}>
              {formatMessage(commonStore, 'languageObj.commonLocale.download')}
            </Button>
          </div> */}
          <AntdTable
            rowKey={record => record.tagUid}
            rowSelection={hasPermission(menu_nfc_report_nfcUidReport) ? rowSelection : null}
            dataSource={tableList}
            columns={tableColumns}
            // 独一无二的标识，不能重复
            columnsKey={'columns_nfcUidReport_' + hasPermission(menu_nfc_uid_report_status_view)}
            pagination={pagination}
            onChange={handleTableChange}
          />
        </div>
      </Card>
      <Modal
        open={modalVisible}
        maskClosable={false}
        destroyOnClose={true}
        className="nike_modal"
        width="70%"
        title={formatMessage(commonStore, 'languageObj.nfcUIDReport.nfcUidReport')}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        footer={null}
      >
        <NfcUIDModalTable productCode={selectProductCode} />
      </Modal>
    </div>
  )
}
export default NFCUIDReportPage
